import { render, staticRenderFns } from "./FinalScoreBox.vue?vue&type=template&id=59541e7e&scoped=true&"
import script from "./FinalScoreBox.vue?vue&type=script&lang=ts&"
export * from "./FinalScoreBox.vue?vue&type=script&lang=ts&"
import style0 from "./FinalScoreBox.vue?vue&type=style&index=0&id=59541e7e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59541e7e",
  null
  
)

export default component.exports